import { render, staticRenderFns } from "./SurveyTemplateQuestion.vue?vue&type=template&id=453900cd"
import script from "./SurveyTemplateQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyTemplateQuestion.vue?vue&type=script&lang=js"
import style0 from "./SurveyTemplateQuestion.vue?vue&type=style&index=0&id=453900cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports